import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the no-op service worker so Android Chrome fires the
// "Add to Home Screen" prompt and the app launches in standalone mode
// once installed. The service worker itself does no caching — see
// public/service-worker.js for why.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.debug("SW registration failed:", err));
  });
}
